import { AppCache } from '../services/app-cache';
import { createStore } from '@orderx/lab/xr/store';
import { Api } from '@orderx/lab/xr/http';
import axios from 'axios';
import { useEffectOnce } from 'usehooks-ts';

const KEY = 'device-fingerprint';
const APP_CACHE_KEY = 'deviceFingerprint';

const { useStore } = createStore(AppCache.get(APP_CACHE_KEY));

export namespace Session$ {
    export function Register() {
        const [_deviceFingerprint, setDeviceFingerprint] = useStore();

        useEffectOnce(() => {
            const deviceFingerprint = _deviceFingerprint || createFingerprint();

            AppCache.set(APP_CACHE_KEY, deviceFingerprint);
            Api.setHeaders({ [KEY]: deviceFingerprint });
            setDeviceFingerprint(deviceFingerprint);
            setAxiosFingerprint(deviceFingerprint);
        });

        return null;
    }

    export function setAxiosFingerprint(value: string) {
        axios.defaults.headers.common = axios.defaults.headers.common || {};
        axios.defaults.headers.common[KEY] = value;
    }

    function createFingerprint() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8;

            return v.toString(16);
        });
    }
}
